import Button from '@/shared/Buttons/Button'
import { NavLink } from 'react-router-dom'
import GoToIcon from '@/assets/icons/goToLink.svg?react'

interface IProps {
  to: string
  text?: string
  renderGoToIcon?: boolean
}

const GoToLinkButton = ({ to, text = 'Перейти на страницу', renderGoToIcon = true }: IProps) => {
  return (
    <NavLink to={to} style={{ textDecoration: 'none' }}>
      <Button size="small" type="tetriary" text={text} icon={renderGoToIcon && <GoToIcon />} isLink={true} />
    </NavLink>
  )
}

export default GoToLinkButton
